import { c as _c } from "react-compiler-runtime";
import { MagpieConnection } from 'magpie-lib/connection';
import { AudienceFilter, MagpieConfigManager } from 'magpie-lib/models';
import { useEffect } from 'react';
import { useEventCallback } from '../hooks/useEventCallback';
import { getBenderProject } from './bender';
import Raven from 'raven-js';
const getTopic = topic => {
  return MagpieConnection.get().useTopic(topic);
};
export const useMagpieTopic = t0 => {
  "use memo";

  const $ = _c(6);
  const {
    topic,
    message,
    onMessage
  } = t0;
  const skip = !onMessage;
  const stableOnMessage = useEventCallback(onMessage);
  let t1;
  let t2;
  if ($[0] !== message || $[1] !== skip || $[2] !== stableOnMessage || $[3] !== topic) {
    t1 = () => {
      if (skip) {
        return;
      }
      const unsubscribe = getTopic(topic).on(message.getType(), stableOnMessage);
      return () => unsubscribe();
    };
    t2 = [message, skip, stableOnMessage, topic];
    $[0] = message;
    $[1] = skip;
    $[2] = stableOnMessage;
    $[3] = topic;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
};
export const buildAudience = win => {
  const builder = AudienceFilter.builder().crossTab(false).crossPortal(false);
  try {
    const benderProject = getBenderProject(win);
    if (!benderProject) {
      throw new Error();
    }
    const isEmbeddableApp = benderProject === 'collaboration-sidebar-embeddable';
    const targetProject = isEmbeddableApp ? getBenderProject(win.parent) : benderProject;
    if (!targetProject) {
      throw new Error();
    }
    builder.byApplication({
      name: targetProject
    });
    const embeddableAppName = `${targetProject}-collaboration-sidebar-embeddable`;
    builder.byApplication({
      name: embeddableAppName
    });
    if (isEmbeddableApp) {
      const cfgManager = MagpieConfigManager.getInstance();
      cfgManager.set('appName', embeddableAppName);
    }
  } catch (error) {
    /**
     * In test environments, we won't have any of the product metadata so we fallback
     * to a less restrictive audience. We also want to capture this error so we can can flag
     * if it is happening in contexts we don't expect.
     */
    Raven.captureException(new Error('Unable to determine audience for Collaboration Sidebar messaging, application may experience undefined behavior'));
    console.warn('Unable to determine audience for Collaboration Sidebar messaging, application may experience undefined behavior');
  }
  const audience = builder.build();
  return audience;
};
export const CollaborationSidebarAudience = buildAudience(window);